export function shortenAddress (address, chars = 4) {
  return `${address.substring(0, chars + 2)}...${address.substring(42 - chars)}`
}

export function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string
}
